const language = {
	spanish: {
		header_title: "Indice de carreras y ",
		header_span_title: "oportunidades de trabajo",
		card_button_text: "Postularse",
		final_button_text: "MOSTRAR MÁS",
	},
	english: {
		header_title: "Career index and ",
		header_span_title: "job opportunities",
		card_button_text: "Apply at",
		end_button_text: "SHOW MORE",
	},
};

export default language;
